export default __webpack_public_path__ + "static/media/step2.c23db4dc.png";